module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("mdi-file-check")]), _vm._v(" Invoices\n      ")], 1)]), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "mt-3 no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "mb-3 mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [(_vm.selectedItems && _vm.selectedItems.length > 0) ? _c('div', [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteInvoice(_vm.selectedItems)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": ""
    }
  }, [_vm._v("mdi-delete")]), _vm._v(" Delete\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.downloadInvoices()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": ""
    }
  }, [_vm._v("mdi-download")]), _vm._v(" Download (" + _vm._s(_vm.selectedItems.length) + ")\n                ")], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Uploaded Date",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.searchFilter()
            }
          },
          model: {
            value: (_vm.filter.searchMonth),
            callback: function($$v) {
              _vm.$set(_vm.filter, "searchMonth", $$v)
            },
            expression: "filter.searchMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.filter.monthPicker),
      callback: function($$v) {
        _vm.$set(_vm.filter, "monthPicker", $$v)
      },
      expression: "filter.monthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.filter.searchMonth),
      callback: function($$v) {
        _vm.$set(_vm.filter, "searchMonth", $$v)
      },
      expression: "filter.searchMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelMonth()
      }
    }
  }, [_vm._v("\n                      Cancel\n                  ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchMonthOk()
      }
    }
  }, [_vm._v("\n                      OK\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter.search),
      callback: function($$v) {
        _vm.$set(_vm.filter, "search", $$v)
      },
      expression: "filter.search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "table-small elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "items-per-page": 10,
      "search": _vm.filter.search,
      "no-data-text": 'Empty list',
      "show-select": "",
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllItems
    },
    scopedSlots: _vm._u([{
      key: "item.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-checkbox', {
          staticClass: "custom-checkbox",
          attrs: {
            "label": "",
            "value": item,
            "color": "grey darken-2"
          },
          model: {
            value: (_vm.selectedItems),
            callback: function($$v) {
              _vm.selectedItems = $$v
            },
            expression: "selectedItems"
          }
        })]
      }
    }, {
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('social-handle', {
          attrs: {
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": item.platform === 'instagram',
            "tiktokHandle": item.handle,
            "instagramHandle": item.handle
          }
        })], 1)]
      }
    }, {
      key: "item.swiftCode",
      fn: function(ref) {
        var item = ref.item;

        return [(item.swiftCodeEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'swiftCode')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.swiftCode))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.swiftCode),
            callback: function($$v) {
              _vm.$set(item, "swiftCode", $$v)
            },
            expression: "item.swiftCode"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.bankAccount",
      fn: function(ref) {
        var item = ref.item;

        return [(item.bankAccountEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'bankAccount')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.bankAccount))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.bankAccount),
            callback: function($$v) {
              _vm.$set(item, "bankAccount", $$v)
            },
            expression: "item.bankAccount"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.username",
      fn: function(ref) {
        var item = ref.item;

        return [(item.usernameEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'username')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.username))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.username),
            callback: function($$v) {
              _vm.$set(item, "username", $$v)
            },
            expression: "item.username"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("\n                  " + _vm._s(item.amount || '-') + "\n                  "), (item.GST) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "warning",
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            "title": "Include GST 9%"
          }
        }, [_vm._v("mdi-alert-circle-outline")]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.remarks",
      fn: function(ref) {
        var item = ref.item;

        return [(item.remarksEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'remarks')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.remarks || '-'))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.remarks),
            callback: function($$v) {
              _vm.$set(item, "remarks", $$v)
            },
            expression: "item.remarks"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.createdAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.utils.formatCustomDate(item.createdAt, 'DD/MM/YYYY')) + "\n                ")])])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Invoice",
            "href": item.invoice.url,
            "color": "info",
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-eye")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action mb-2",
          staticStyle: {
            "height": "36px"
          },
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openEditModal(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action mb-2",
          staticStyle: {
            "height": "36px"
          },
          attrs: {
            "color": "error",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteInvoice([item])
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-delete")])], 1)]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-015a6d0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/UploadedInvoiceListModal.vue
// module id = 1966
// module chunks = 0